import { gql } from "@stadium/services/apollo-client";

import { PRODUCT_SEARCH_SERVER_BASICS_DETAILS } from "./server";

export const PRODUCT_SEARCH_BASICS_DETAILS = gql`
  ${PRODUCT_SEARCH_SERVER_BASICS_DETAILS}
`;
